<template>
  <div class="available-inspectors-container">
    <div class="available-inspectors-header" v-if="showInspectorsHeader">
      <span class="available-inspectors-header-text"
        >You can ask anyone of these Coaches or Masters to Inspect you for this
        Responsibility</span
      >
    </div>
    <div class="available-inspectors ml-3 my-2">
      <InspectorCard
        v-for="(coach, index) in sortedCoaches"
        :key="index"
        :badge-level="coach.badgeLevel"
        :first_name="coach.firstName"
        :last_name="coach.lastName"
        :title="coach.title"
        :avatar="coach.img"
        :is-hover-enabled="coach.isHoverEnabled"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, ref, defineProps } from "vue";
import InspectorCard from "@components/InspectorCard/InspectorCard.vue";
const props = defineProps({
  availableInspectors: {
    type: Array,
    default: () => [],
  },
  showInspectorsHeader: {
    type: Boolean,
    default: false,
  },
});
const sortedCoaches = computed(() => {
  const badgePriority = { Master: 0, Coach: 1 }; // Lower value = higher priority
  return [...props?.availableInspectors].sort((a, b) => {
    const badgeDiff =
      (badgePriority[a?.badgeLevel] ?? 99) -
      (badgePriority[b?.badgeLevel] ?? 99);
    if (badgeDiff !== 0) return badgeDiff;

    return a?.firstName?.localeCompare(b?.firstName);
  });
});
</script>

<style scoped>
.available-inspectors-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.available-inspectors {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.available-inspectors-header {
  background-color: #f9fafb;
  border-bottom: 1px solid #eaecf0;
  border-top: 1px solid #eaecf0;
  padding: 10px 14px;
}
.available-inspectors-header-text {
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0%;
  color: #101828;
}
</style>
